import { render, staticRenderFns } from "./BizInsuranceDataForm.vue?vue&type=template&id=7d38bc62&"
import script from "./BizInsuranceDataForm.vue?vue&type=script&lang=js&"
export * from "./BizInsuranceDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports